import { useNavigate } from 'react-router-dom'

import { useUser } from 'api'
import { ReactComponent as Logout } from '../assets/navIcons/logout.svg'
import { Confirm, useConfirmControls } from '../Confirm'

import styles from './TopBar.module.scss'

export const LogoutButton = () => {
  const navigate = useNavigate()
  const { logout } = useUser()

  const confirmControls = useConfirmControls()
  const { open: openConfirm, close: closeConfirm } = confirmControls

  const handleLogout = async () => {
    closeConfirm()
    await logout()
    navigate('/login')
  }

  return (
    <>
      <button id='logout' title='Log Out' className={styles['logout']} onClick={openConfirm}>
        <Logout />
      </button>
      <Confirm controls={confirmControls} onConfirm={handleLogout} title={'Log Out'} confirmBtnCopy='Log Out'>
        <>
          <p>Are you sure you want to log out?</p>
          <p>Unsaved progress will be saved automatically.</p>
        </>
      </Confirm>
    </>
  )
}
